import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { store } from './reducer';
import { LinearProgress } from '@material-ui/core';
import formatNumber from '../../../../../fns/formatNumber';
import useRules from 'hooks/useRules';


const useStyles = makeStyles((theme) => ({
  commissionStatus: {
    background: '#d1c4e9',
    color: '#311b92',
    padding: theme.spacing(1),
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& > div > span:first-child': {
      fontWeight: 'bold',
    },
    '& > div > span:last-child': {
      marginLeft: theme.spacing(1),
    },
  },
}));

const CommissionsDetails = () => {
  const classes = useStyles();
  const {
    state: { order, commissions },
  } = useContext(store);
  const [rules, hasRule, isAdmin] = useRules();


  if (!order || !commissions) {
    return <LinearProgress />;
  }
  return (
    <div className={classes.commissionStatus}>
      <div>
        <span>پیشنهاد صاحب‌بار:</span>
        <span>
          {order?.proposedPrice
            ? formatNumber(order.proposedPrice) + ' تومان'
            : 'توافقی'}
        </span>
      </div>
     {isAdmin &&  <div>
        <span>{`کارمزد شرکت:${
          order?.waybillType === 'police' ? `(پلیس راهی)` : ''
        }${order?.waybillType === 'custom' ? `(سفارشی)` : ''}`}</span>
        <span>{formatNumber(commissions?.commissions || 0)} تومان</span>
      </div> }
      <div>
        <span>بیمه بار:</span>
        <span>{formatNumber(commissions?.insurance || 0)} تومان</span>
      </div>
      <div className={classes.driversShare}>
        <span>صافی رانندگان:</span>
        <span>
          {order?.proposedPrice
            ? formatNumber(order?.proposedPrice * 1 - commissions.subs * 1) +
              ' تومان'
            : 'توافقی'}
        </span>
      </div>
      <div style={{ border: '1px solid #000', padding: 5 }}>
        <span>کمیسیون دریافتی:</span>
        <span>{formatNumber(commissions?.subs)} تومان</span>
      </div>
    </div>
  );
};

export default CommissionsDetails;
